
import { createRouter, createWebHistory } from 'vue-router';
import login from './views/login.vue';
import chat from './views/chat.vue';


const routes = [
  {
    path: '/',
    name: 'chat',
    component: chat,
  },
  {
    path: '/login',
    name: 'login',
    component: login,
  },
];

const router = createRouter({
  history: createWebHistory(), // 使用 history 模式
  routes,
});

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('authToken');
  if (to.path === '/login' && token) {
    // 已登录，禁止访问登录页
    next('/');
  } else if (to.path !== '/login' && !token) {
    // 未登录，跳转到登录页
    next('/login');
  } else {
    next();
  }
});

export default router;
